var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-card',{staticClass:"vg-collapse-panel no-padding",class:{'fixed-on': _vm.fixedOn}},[_c('van-collapse',{attrs:{"value":_vm.activeNames},on:{"input":_vm.onInput}},[_c('van-collapse-item',{attrs:{"title":_vm.title,"name":"1"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }